import { careerContent } from '@/mocks/homeData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CareerSection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal(0.1);
  const { ref: listRef, isVisible: listVisible } = useScrollReveal(0.1);

  return (
    <section
      id="career"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-50"
    >
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div
            className={`text-center mb-12 md:mb-16 transition-all duration-700 ${
              sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium tracking-wider bg-primary-100 text-primary-700 mb-4">
              About the Attorney
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              {careerContent.sectionTitle}
            </h2>
            <p className="mt-3 text-base md:text-lg text-foreground-600">
              {careerContent.sectionSubtitle}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
            <div
              className={`relative transition-all duration-700 delay-100 ${
                sectionVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'
              }`}
            >
              <div className="relative aspect-[3/4] max-w-md mx-auto lg:mx-0 rounded-2xl overflow-hidden bg-background-200">
                <img
                  src={careerContent.attorneyPhotoLight}
                  alt={careerContent.sectionTitle}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-6 md:p-8">
                  <p className="text-background-50 font-semibold text-lg">
                    {careerContent.attorneyName}
                  </p>
                  <p className="text-background-300 text-sm mt-1">
                    {careerContent.keyword}
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary-500/10 rounded-full blur-2xl" />
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-accent-500/10 rounded-full blur-2xl" />
            </div>

            <div className="space-y-8">
              <div className="flex flex-wrap gap-2">
                {careerContent.badges.map((badge) => (
                  <span
                    key={badge}
                    className="inline-block px-3 py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary-100 text-primary-700 border border-primary-200/50"
                  >
                    {badge}
                  </span>
                ))}
              </div>

              <p
                className={`text-base md:text-lg text-foreground-700 leading-relaxed transition-all duration-700 delay-300 ${
                  sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
              >
                {careerContent.intro}
              </p>

              <div
                ref={listRef}
                className={`space-y-3 transition-all duration-700 delay-400 ${
                  listVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
              >
                {careerContent.careers.map((item) => {
                  const match = item.match(/^(.+?)\s*(\(.+\))$/);
                  return (
                    <div
                      key={item}
                      className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-background-100/60 border border-background-200/50 hover:bg-background-100 transition-colors"
                    >
                      <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                        <i className="ri-check-line text-primary-500" />
                      </span>
                      <span className="text-sm md:text-base text-foreground-800">
                        {match ? (
                          <>
                            {match[1]}
                            <span className="text-xs md:text-sm text-foreground-500"> {match[2]}</span>
                          </>
                        ) : (
                          item
                        )}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}